import React from "react";
import styled, { css } from "styled-components";

const Badge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 34px;
  padding: 0 12px;
  border-radius: 999px;
  font-size: 12px;
  font-weight: 800;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  border: 1px solid transparent;

  ${({ $variant }) =>
    $variant === "confirmata" &&
    css`
      background: rgba(201, 162, 39, 0.12);
      border-color: rgba(201, 162, 39, 0.25);
      color: #b78a00;
    `}

  ${({ $variant }) =>
    $variant === "in_lucru" &&
    css`
      background: rgba(44, 123, 229, 0.12);
      border-color: rgba(44, 123, 229, 0.35);
      color: #2c7be5;
    `}

  ${({ $variant }) =>
    $variant === "gata" &&
    css`
      background: rgba(47, 150, 87, 0.12);
      border-color: rgba(47, 150, 87, 0.3);
      color: #2f9657;
    `}

  ${({ $variant }) =>
    ($variant === "ridicata" ||
      $variant === "livrata" ||
      $variant === "platit") &&
    css`
      background: rgba(47, 150, 87, 0.12);
      border-color: rgba(47, 150, 87, 0.3);
      color: #207849;
    `}

  ${({ $variant }) =>
    ($variant === "anulata" || $variant === "esuat") &&
    css`
      background: rgba(210, 55, 55, 0.12);
      border-color: rgba(210, 55, 55, 0.35);
      color: #d23737;
    `}

  ${({ $variant }) =>
    ($variant === "pending" || $variant === "neplatit") &&
    css`
      background: rgba(201, 162, 39, 0.1);
      border-color: rgba(201, 162, 39, 0.25);
      color: #b78a00;
    `}

  ${({ $variant }) =>
    $variant === "rambursat" &&
    css`
      background: rgba(105, 140, 200, 0.12);
      border-color: rgba(105, 140, 200, 0.3);
      color: #4f6fae;
    `}
`;

export function orderStatusLabel(status) {
  switch (status) {
    case "confirmata":
      return "Confirmată";
    case "in_lucru":
      return "În lucru";
    case "gata":
      return "Gata";
    case "ridicata":
      return "Ridicată";
    case "livrata":
      return "Livrată";
    case "anulata":
      return "Anulată";
    default:
      return status || "—";
  }
}

export function paymentStatusLabel(status) {
  switch (status) {
    case "platit":
      return "Plătită";
    case "pending":
      return "În așteptare";
    case "neplatit":
      return "Neplătită";
    case "esuat":
      return "Eșuată";
    case "rambursat":
      return "Rambursată";
    default:
      return status || "—";
  }
}

export function paymentLabel(method) {
  if (method === "card") return "Card online";
  if (method === "cash") return "Numerar la ridicare";
  return method || "—";
}

export default function OrderStatusBadge({ type = "order", value }) {
  const label =
    type === "payment" ? paymentStatusLabel(value) : orderStatusLabel(value);

  const variant = value;

  return <Badge $variant={variant}>{label}</Badge>;
}
